import {
    Component,
    Input,
    ChangeDetectionStrategy,
    SimpleChanges,
    OnChanges,
    ChangeDetectorRef,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { faPen, faTrain } from '@fortawesome/pro-solid-svg-icons';
import { RtCommodityShipped } from '@bds/railtrac-models';
import { firstValueFrom, take } from 'rxjs';
import { RailtracTripService, RtCommodityShippedService } from '@bds/railtrac';
import { Router } from '@angular/router';

@Component({
    selector: 'rt-commodity-shipped-details',
    templateUrl: './rt-commodity-shipped-details.component.html',
    styleUrls: ['./rt-commodity-shipped-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RtCommodityShippedDetailsComponent implements OnChanges {
    @Input() commodityShippedList: RtCommodityShipped[] = [];
    @Input() count = 0;

    commodityShipped: RtCommodityShipped[] = [];
    expandedCommodityShipped: RtCommodityShipped = new RtCommodityShipped();
    errors: any[] = [];
    headerSize: string = 'h3';
    iconTrain = faTrain;
    iconEdit = faPen;
    isLoading = false;

    constructor(
        private tripService: RailtracTripService,
        private commodityShippedService: RtCommodityShippedService,
        private snackbar: MatSnackBar,
        private router: Router,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['commodityShippedList']) {
            if (this.commodityShippedList) {
                this.isLoading = true;

                const ormIds: number[] = this.commodityShippedList.map((item) => item.ormId ?? 0);

                this.commodityShippedService
                    .readCombinedByOrmId(ormIds)
                    .pipe(take(1))
                    .subscribe((result) => {
                        if (result) {
                            this.commodityShipped = result.commoditiesShipped;
                        }
                        this.isLoading = false;
                        this.cdr.markForCheck();
                    });
            }
        }
    }

    /**
     * Open the Current Trip page in a new tab.
     * @returns void
     */
    async currentTrip(): Promise<void> {
        const selectedCommodityShipped = this.commodityShippedList?.[0];
        try {
            if (!selectedCommodityShipped?.carInit || !selectedCommodityShipped?.carNo) {
                this.snackbar.open('Missing car information', 'Error', { duration: 3000 });
                return;
            }

            // Get the current trip for the specific car
            const currentTrip = await firstValueFrom(
                this.tripService.findCurrentTrip(
                    selectedCommodityShipped.carInit,
                    selectedCommodityShipped.carNo,
                ),
            );

            if (!currentTrip) {
                this.snackbar.open('No current trip found for this car', 'Info', {
                    duration: 3000,
                });
                return;
            }

            this.snackbar.open(
                `Current trip found: ${currentTrip.carInit} ${currentTrip.carNo} - ${
                    currentTrip.shipDatetime
                        ? new Date(currentTrip.shipDatetime).toLocaleDateString()
                        : ''
                }`,
                'Ok',
                { duration: 3000 },
            );

            const url = this.router.serializeUrl(
                this.router.createUrlTree(['/trip', currentTrip.ormId], {
                    queryParams: { fromInterfaceValidation: 'true' },
                }),
            );
            window.open(url, '_blank');
        } catch (error) {
            this.snackbar.open('Error fetching current trip', 'Error', { duration: 3000 });
        }
    }
}
